import {
    INoteCategoryTypeModel,
    INoteModel,
    INoteSubCategoryTypeModel,
} from '../../../interfaces/INote';

import CheckmateSelect from '../../shared/CheckmateSelect';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IValidation } from '../../../interfaces/IError';

interface ISubCategoriesProps {
    currentNote: INoteModel;
    noteCategoryTypes: INoteCategoryTypeModel[];
    onSubCategoryChange: (optionsList: any) => void;
    selectedNoteCategories: IMultiSelectOption[];
    validation: IValidation;
}

export function SubCategories(props: ISubCategoriesProps) {
    if (props.selectedNoteCategories.length == 0) return null;

    const categoriesWithSubCategories = props.selectedNoteCategories.filter((noteCategory) => {
        const noteCategoryTypeLookup = props.noteCategoryTypes.find(
            (x) => x.id === noteCategory.id
        );
        return (noteCategoryTypeLookup?.subCategories?.length ?? 0) > 0;
    });

    return (
        <>
            {categoriesWithSubCategories.map((noteCategory) => {
                const subCategoryId =
                    props.currentNote.categories?.find((x) => x.id === noteCategory.id)?.subCategory
                        ?.id ?? 0;

                return (
                    <SubCategory
                        key={subCategoryId}
                        categoryId={noteCategory.id}
                        noteCategoryTypes={props.noteCategoryTypes}
                        onSubCategoryChange={props.onSubCategoryChange}
                        subCategoryId={subCategoryId}
                        validation={props.validation}
                    />
                );
            })}
        </>
    );
}

interface ISubCategoryProps {
    categoryId: number;
    noteCategoryTypes: INoteCategoryTypeModel[];
    onSubCategoryChange: (optionsList: any) => void;
    subCategoryId: number;
    validation: IValidation;
}

function SubCategory(props: ISubCategoryProps) {
    const getNoteSubCategoryOptions = (values: INoteSubCategoryTypeModel[]) => {
        const options: IMultiSelectOption[] = [];
        for (let i = 0; i < values.length; i++) {
            options.push({
                label: values[i].displayName!,
                value: values[i].name!,
                id: values[i].id,
                guid: values[i].guid!,
            });
        }
        return options;
    };

    const getSelectedNoteSubCategoryValue = (values: INoteSubCategoryTypeModel[], id: number) => {
        const match = values.find((x) => x.id === id);
        if (match) {
            return {
                label: match.displayName!,
                value: match.name!,
                id: match.id,
                guid: match.guid!,
            };
        }
    };

    const noteCategoryTypeLookup = props.noteCategoryTypes.find((x) => x.id === props.categoryId);

    const selectedSubCategoryValue = getSelectedNoteSubCategoryValue(
        noteCategoryTypeLookup?.subCategories ?? [],
        props.subCategoryId
    );

    return (
        <div className="row mb-2">
            <div className="col-sm-2">
                <label className="text-gray">
                    Sub Category for {noteCategoryTypeLookup?.displayName}*
                </label>
            </div>
            <div className="col-sm-5 d-inline-block">
                <CheckmateSelect
                    options={getNoteSubCategoryOptions(noteCategoryTypeLookup?.subCategories ?? [])}
                    name="subCategory"
                    value={selectedSubCategoryValue}
                    onChange={props.onSubCategoryChange}
                />
                <span className="text-danger padding-10">{props.validation.subCategory}</span>
            </div>
        </div>
    );
}
